export const setForRefund = (forRefund) => ({
    type: 'SET_FOR_REFUND',
    payload: forRefund,
  });